export default __webpack_public_path__ + "static/media/Aphrodite-light.9d2cbbc7.gif";